
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-pfp-maker",
      function () {
        return require("private-next-pages/ai-pfp-maker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-pfp-maker"])
      });
    }
  